/* import __COLOCATED_TEMPLATE__ from './procedure-dependency.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import Component from '@glimmer/component';

interface ProcedureDependencySignature {
  Args: {
    hasDependentProcedures?: boolean;
  };
}

export default class ProcedureDependency extends Component<ProcedureDependencySignature> {
  get hasDependency(): boolean {
    return this.args.hasDependentProcedures === true;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::FilterableList::Table::Cells::ProcedureDependency': typeof ProcedureDependency;
    'knowledge-hub/filterable-list/table/cells/procedure-dependency': typeof ProcedureDependency;
  }
}
